export default __webpack_public_path__ + "static/chocolate-c1a98c9fd3fb15081359852e3e4bcdd3.png";